
import * as React from "react";
import { cn } from "@/lib/utils";
import { ChevronDown, ChevronRight } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { SidebarGroup, SidebarGroupLabel } from "./SidebarGroup";

interface SidebarSectionProps {
  title: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const SidebarSection: React.FC<SidebarSectionProps> = ({
  title,
  isOpen,
  onOpenChange,
  action,
  children,
  className
}) => {
  return (
    <SidebarGroup className={cn("border border-border rounded-md p-0", className)}>
      <Collapsible open={isOpen} onOpenChange={onOpenChange}>
        <CollapsibleTrigger className="w-full">
          <SidebarGroupLabel className="px-3 h-8 flex items-center justify-between cursor-pointer">
            <div className="flex items-center">
              {isOpen ? 
                <ChevronDown className="h-4 w-4 mr-1" /> : 
                <ChevronRight className="h-4 w-4 mr-1" />
              }
              <h2 className="text-xs font-medium uppercase">{title}</h2>
            </div>
            {action}
          </SidebarGroupLabel>
        </CollapsibleTrigger>
        
        <CollapsibleContent>
          {children}
        </CollapsibleContent>
      </Collapsible>
    </SidebarGroup>
  );
};

export default SidebarSection;
